import request from '@/utils/request'

// 【作者主页】获取作者信息
export function getAuthorInfo (params) {
  return request({
    url: 'app/person/author_info',
    method: 'post',
    data: params
  })
}

// 【作者主页】获取作者个人作品列表
export function getAuthorWorks (params) {
  return request({
    url: 'app/person/get_author_works',
    method: 'post',
    data: params
  })
}

// 【书刊】获取图书详情
export function getBookInfo (params) {
  return request({
    url: 'app/book_periodicals/get_doc_info',
    method: 'post',
    data: params
  })
}

// 【期刊】获取期刊详情
export function getPeriodicalsInfo (params) {
  return request({
    url: 'app/book_periodicals/get_periodicals',
    method: 'post',
    data: params
  })
}

// 【期刊】获取期刊稿件列表
export function getPeriodicalsList (params) {
  return request({
    url: 'app/book_periodicals/list_periodicals_manuscript',
    method: 'post',
    data: params
  })
}

// 【期刊】获取往期期刊列表
export function getPrevPeriodicalsList (params) {
  return request({
    url: 'app/book_periodicals/get_journal_date',
    method: 'post',
    data: params
  })
}

// 【图组】获取图片详情
export function getPictureInfo (params) {
  return request({
    url: 'app/picture_group/picture_info',
    method: 'post',
    data: params
  })
}

// 获取微信配置信息
export function getWxConfigInfo (data) {
  return request({
    url: 'app/wechat/getJsApi_app',
    method: 'get',
    params: data
  })
}

// 获取 android 最新版本连接地址
export function getAndroidLatestVersion (params) {
  return request({
    url: 'app/configuration/get_latest_version',
    method: 'post',
    data: params
  })
}

// 【文章】获取文章详情
export function getArticleInfo (params) {
  return request({
    url: 'app/home/get_article_info',
    method: 'post',
    data: params
  })
}

// 【文章】获取文章评论
export function getCommentList (params) {
  return request({
    url: 'app/article/get_comment',
    method: 'post',
    data: params
  })
}

// 【图集】获取图集浏览量
export function getReadCount (id) {
  return request({
    url: `app/newsArticle/readCount/${id}`,
    method: 'get'
  })
}

// 【图集】浏览量+1
export function readCountPlusOne (id) {
  return request({
    url: `app/newsArticle/articleReadingPlusOne/${id}`,
    method: 'get'
  })
}

// 获取广告信息
export function advertisementAPI () {
  return request({
    url: 'app/AppAdvArticle/findLastByCompid',
    method: 'get'
  })
}

// 获取推荐阅读
export function getRecommentArticleList () {
  return request({
    url: 'app/article/Recommend',
    method: 'get'
  })
}